import { useState } from "react";
import { useOrgApps } from "@/hooks/useOrgApps";
import { signOut } from "@/lib/auth";
import { VERSION_DISPLAY } from "@/lib/version";
import type { OrgUserRole } from "@/types/firestore";
import {
  OrganizationPortalNavigationView,
} from "@/components/portal/OrganizationPortalNavigationView";
import { portalNavItems, portalRoleLabels } from "@/lib/portalNavigation";

interface OrganizationPortalNavigationProps {
  orgId: string | undefined;
  role: OrgUserRole;
  isImpersonating: boolean;
  userName?: string;
  userEmail?: string;
}

export function OrganizationPortalNavigation({
  orgId,
  role,
  isImpersonating,
  userName,
  userEmail,
}: OrganizationPortalNavigationProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const resolved = useOrgApps(orgId, true);
  const org = resolved.org?.id === orgId ? resolved.org : null;
  const apps = org ? resolved.apps : [];
  const items = portalNavItems({
    hasApps: apps.length > 0,
    workshopsEnabled: org?.features?.workshops?.enabled === true,
    supportEnabled: org?.features?.support?.enabled === true,
  });
  const roleLabel = isImpersonating
    ? "Viewing as Organization Owner"
    : portalRoleLabels[role] || "Organization Administrator";

  return (
    <OrganizationPortalNavigationView
      organizationName={org?.name || "Organization"}
      organizationLogo={org?.logo}
      roleLabel={roleLabel}
      userName={userName}
      userEmail={userEmail}
      versionLabel={VERSION_DISPLAY}
      items={items}
      mobileOpen={mobileOpen}
      onMobileToggle={() => setMobileOpen((open) => !open)}
      onSignOut={() => signOut()}
    />
  );
}
